import { render, staticRenderFns } from "./Company_abs_tel.vue?vue&type=template&id=49fdd7a0&scoped=true&lang=pug&"
import script from "./Company_abs_tel.vue?vue&type=script&lang=coffee&"
export * from "./Company_abs_tel.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fdd7a0",
  null
  
)

export default component.exports